import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Why from "@/components/Why";
import HowItHelps from "@/components/HowItHelps";
import WhoItsFor from "@/components/WhoItsFor";
import CtaCard from "@/components/CtaCard";
import Footer from "@/components/Footer";
import SignupModal from "@/components/SignupModal";

export default function App() {
    const [signupOpen, setSignupOpen] = useState(false);
    const openSignup = () => setSignupOpen(true);

    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.05,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            anchors: true,
        });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App min-h-screen bg-[#E7E7E1] flex justify-center font-body" data-testid="medcheck-app">
            <div className="w-full max-w-[540px] bg-cream relative sm:shadow-[0_0_80px_rgba(0,0,0,0.18)]">
                <Header />
                <main>
                    <Hero onSignup={openSignup} />
                    <Why />
                    <HowItHelps />
                    <WhoItsFor />
                    <CtaCard onSignup={openSignup} />
                </main>
                <Footer />
            </div>
            <SignupModal open={signupOpen} onClose={() => setSignupOpen(false)} />
            <Toaster position="bottom-center" toastOptions={{ style: { background: "#111111", color: "#FAF9F6", border: "none" } }} />
        </div>
    );
}
